<template>
  <div :class="isHeaderTitle ? 'header-title-container' : 'title-container'">
    <div style="display: flex; align-items: center">
      <component
        :is="iconName"
        :theme="theme"
        :size="size"
        :fill="fill"
        v-if="showPrefixIcon"
        @click="handleClick"
        style="margin-right: 12px; cursor: pointer"
      />
      <div :class="isHeaderTitle ? 'header-title' : 'title'">
        {{ title }}
      </div>
    </div>
    <div class="center-slot">
      <slot name="center"></slot>
    </div>
    <div class="right-slot">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
import { Return } from '@icon-park/vue'
export default {
  components: { Return },
  props: {
    title: {
      type: String,
      default: '标题',
      required: true,
    },
    isHeaderTitle: {
      type: Boolean,
      default: false,
    },
    showPrefixIcon: {
      type: Boolean,
      default: false,
    },
    iconName: {
      type: String,
      default: 'Return',
    },
    theme: {
      type: String,
      default: 'outline',
    },
    size: {
      type: String,
      default: '24',
    },
    fill: {
      type: String,
      default: '#00000045',
    },
  },
  methods: {
    handleClick() {
      this.$emit('click')
    },
  },
}
</script>

<style lang="less" scoped>
.title-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  .title {
    font: 700 16px/24px AlibabaSans-Black;
  }
  .right-slot {
    display: flex;
    align-items: center;
  }
}
.header-title-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 64px;
  .header-title {
    font: 700 20px/28px AlibabaSans-Black;
  }
  .center-slot{
    color: #000000d9;
     font-family: "PingFang SC";
     font-size: 16px;
     font-weight: 500;
  }
  .right-slot {
    display: flex;
    align-items: center;
  }
}
</style>
